import request from 'utils/request'

export const getTableData = data => request().post('legal/get', data)

export const remove = id => request().post(`legal/delete/${id}`)

export const add = data => request().post('legal/add', data)
